module.exports = __webpack_public_path__ + "img/a39.e42b2a4c.svg";